//**auto-generated don't edit this code**//
export enum Difficulty {
	None,
	Easy,
	Medium,
	Hard,
}